import { type FC, type ComponentProps } from "react";

import { cn } from "@/shared/lib/utils";

type CurrencyInputProps = Omit<ComponentProps<"input">, "type"> & {
  prefix?: string;
  wrapperClassName?: string;
};

export const CurrencyInput: FC<CurrencyInputProps> = ({
  prefix = "$",
  className,
  wrapperClassName,
  ...props
}) => {
  return (
    <div
      className={cn(
        "flex items-center h-10 rounded-md border border-primary bg-white transition-colors focus-within:border-focus",
        wrapperClassName,
      )}
    >
      <span className="shrink-0 pl-3 text-sm text-secondary select-none">{prefix}</span>
      <input
        type="text"
        data-slot="input"
        className={cn(
          "h-full w-full bg-transparent pl-1.5 pr-3 py-1.5 text-sm text-primary outline-none",
          "placeholder:text-tertiary",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        {...props}
      />
    </div>
  );
};
